export default __webpack_public_path__ + "static/media/480_dummy2016-meditation01-de.ef0b5900.png";